import { xor } from 'lodash'

export type ColorizedDocumentReviewStatus = 'gray' | 'green'
export type DocumentReviewStatus = 'needs_review' | 'reviewed'
export type HumanizedDocumentReviewStatus = 'Needs review' | 'Reviewed'
export type DocumentReviewStatusIconTypes = 'regular' | 'solid'
export type HumanizedReviewStatusAriaLabel =
  | 'Set to needs review'
  | 'Set to reviewed'

export const DocumentReviewStatusMap = {
  reviewed: {
    label: 'Reviewed',
    color: 'green',
    icon_type: 'solid'
  },
  needs_review: {
    label: 'Needs review',
    color: 'gray',
    icon_type: 'regular'
  }
} as const

export const humanizedReviewStatus = (
  status: DocumentReviewStatus
): HumanizedDocumentReviewStatus => {
  switch (status) {
    case 'reviewed':
    case 'needs_review':
      return DocumentReviewStatusMap[status].label
    default:
      return DocumentReviewStatusMap.needs_review.label
  }
}

export const setReviewStatusAriaLabel = (
  status: DocumentReviewStatus
): HumanizedReviewStatusAriaLabel => {
  switch (status) {
    case 'reviewed':
      return 'Set to needs review'
    case 'needs_review':
      return 'Set to reviewed'
  }
}

export const reviewStatusColor = (
  status: DocumentReviewStatus
): ColorizedDocumentReviewStatus => {
  switch (status) {
    case 'reviewed':
    case 'needs_review':
      return DocumentReviewStatusMap[status].color
    default:
      return DocumentReviewStatusMap.needs_review.color
  }
}

export const reviewStatusBgColor = (
  status: DocumentReviewStatus
): ColorizedDocumentReviewStatus => {
  switch (status) {
    case 'reviewed':
    case 'needs_review':
      return DocumentReviewStatusMap[status].color
    default:
      return DocumentReviewStatusMap.needs_review.color
  }
}

export const toggleReviewStatus = (
  status: DocumentReviewStatus
): DocumentReviewStatus => {
  return xor<DocumentReviewStatus>(
    Object.keys(DocumentReviewStatusMap) as DocumentReviewStatus[],
    [status]
  ).pop()
}

export const reviewStatusIconType = (
  status: DocumentReviewStatus
): DocumentReviewStatusIconTypes => {
  switch (status) {
    case 'needs_review':
      return DocumentReviewStatusMap[status].icon_type
    default:
      return DocumentReviewStatusMap.needs_review.icon_type
  }
}
